import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Product } from '../../types/product.types';

interface WishlistState {
  items: Product[];
  isLoading: boolean;
  error: string | null;
}

const loadWishlistItems = (): Product[] => {
  try {
    const saved = localStorage.getItem('wishlist_items');
    return saved ? JSON.parse(saved) : [];
  } catch (e) {
    return [];
  }
};

const saveWishlistItems = (items: Product[]) => {
  try {
    localStorage.setItem('wishlist_items', JSON.stringify(items));
  } catch (e) {
    console.error('Failed to save wishlist items', e);
  }
};

const initialState: WishlistState = {
  items: loadWishlistItems(),
  isLoading: false,
  error: null,
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    addToWishlistStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    addToWishlistSuccess: (state, action: PayloadAction<Product>) => {
      state.isLoading = false;
      if (!state.items.find(item => item.id === action.payload.id)) {
        state.items.push(action.payload);
        saveWishlistItems(state.items);
      }
      state.error = null;
    },
    addToWishlistFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    removeFromWishlist: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.id !== action.payload);
      saveWishlistItems(state.items);
    },
    clearWishlist: (state) => {
      state.items = [];
      saveWishlistItems([]);
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  addToWishlistStart,
  addToWishlistSuccess,
  addToWishlistFailure,
  removeFromWishlist,
  clearWishlist,
  clearError,
} = wishlistSlice.actions;

export default wishlistSlice.reducer;
